import './header';
import './footer';
import './newsletter';

new Vue({
  delimiters: ['[[', ']]'], // change because vue and django using the same args 
  el: '#footer',
  methods: {
    cartPreview() {
      // Constantes globais
      const CONFIG = {
        API_HEADERS: { 'Content-Type': 'application/json' },
        CART_ENDPOINT: '/api/front/cart/items/?version=2',
        SELECTORS: {
          cartPreview: '.cart-preview',
          shippingOverlay: '.cart-preview__shipping--overlay',
          shipping: '.cart-preview__shipping',
          shippingClose: '.cart-preview__shipping--close',
          itemsList: '.cart_preview-items',
          subtotal: '.cart-preview__sub-total--value',
          discounts: '.cart-preview__discounts--value',
          total: '.cart-preview__total--value',
          counters: '.quant_itens_carrinho',
          footer: '.cart-preview__footer',
          footerUtils: '.cart-preview__footer-utils',
          openUtils: '.open-utils',
          couponInput: '#appendedInputButton',
          removeCoupon: '#removeCoupon',
          shippingForm: '#js_form_shipping_cep_cart_lateral',
          cepInput: '#js_cep_input_cart_lateral',
          shippingList: '.cart-preview__shipping__list',
          selectedShipping: '.selected-shipping',
          // Seletores para a barra de progresso do frete grátis
          freeShippingBar: '.cart-preview-free-shipping__bar--percent',
          freeShippingValueFrom: '.cart-preview-free-shipping__value-from',
          freeShippingValueTo: '.cart-preview-free-shipping__value-to',
          freeShippingTip: '.cart-preview-free-shipping__tip'
        }
      };
      const handleZipCode = (event) => {
        let input = event.target;
        input.value = zipCodeMask(input.value);
      }

      const zipCodeMask = (value) => {
        if (!value) return "";
        value = value.replace(/\D/g, '');
        value = value.replace(/(\d{5})(\d)/, '$1-$2');
        return value;
      }
      const cepInput = document.querySelector('.cart-preview #js_form_shipping_cep_cart_lateral');
      if (cepInput) {
        cepInput.addEventListener('keyup', handleZipCode);
      }

      // Adiciona máscara para o input lateral também
      const cepInputLateral = document.querySelector(CONFIG.SELECTORS.cepInput);
      if (cepInputLateral) {
        cepInputLateral.addEventListener('keyup', handleZipCode);
      }


      // Funções utilitárias
      const utils = {
        formatCurrency: value => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value),

        toggleClasses: (selectors, className, add = true) => {
          selectors.forEach(selector => $(selector)[add ? 'addClass' : 'removeClass'](className));
        },

        addClasses: (selectors, className) => {
          selectors.forEach(selector => $(selector).addClass(className));
        },

        ajaxRequest: (method, url, data, headers = CONFIG.API_HEADERS) => {
          // Garantir que URLs de DELETE sempre tenham barra no final para evitar problemas no iOS 16.1
          let normalizedUrl = url;
          if (method === 'DELETE' && !url.endsWith('/')) {
            normalizedUrl = url + '/';
          }

          return $.ajax({
            type: method,
            url: normalizedUrl,
            headers,
            dataType: 'json',
            data: typeof data === 'object' ? JSON.stringify(data) : data
          });
        },

        updateFooterUtilsHeight: (first) => {
          const utils = document.querySelector(CONFIG.SELECTORS.footerUtils);
          if (utils) {
            utils.querySelectorAll('li').forEach(li => {
              const append = li.querySelector('.input-append');
              if (append) {
                const form = append.querySelector('form');
                const list = append.querySelector('.cart-preview__shipping__list');

                let totalHeight = 0;
                if (form) totalHeight += form.getBoundingClientRect().height;
                if (list) {
                  totalHeight += list.children.length > 0 ? 145 : 0;
                }

                append.style.height = `${totalHeight + 20}px`; // +20px de espaçamento
              }

              if (first) {
                li.classList.add('active');
              }
            });
          }
        },

        // Função para atualizar a barra de progresso do frete grátis
        updateFreeShippingProgress: (currentValue, targetValue, freeShippingLabel, freeShippingLabelSuccess) => {
          const { SELECTORS } = CONFIG;

          // Converter valores para números
          const current = parseFloat(currentValue) || 0;
          const target = parseFloat(targetValue) || 0;

          // Calcular a porcentagem
          let percentage = 0;
          if (target > 0) {
            percentage = Math.min((current / target) * 100, 100);
          }

          // Atualizar a barra de progresso
          const progressBar = document.querySelector(SELECTORS.freeShippingBar);
          if (progressBar) {
            progressBar.style.width = `${percentage}%`;
          }

          // Atualizar os valores exibidos
          const valueFrom = document.querySelector(SELECTORS.freeShippingValueFrom);
          const valueTo = document.querySelector(SELECTORS.freeShippingValueTo);

          if (valueFrom) {
            valueFrom.textContent = utils.formatCurrency(current);
          }

          if (valueTo) {
            // Se o valor atual ultrapassou o valor necessário, mostrar o valor atual em ambos
            const displayValue = current >= target ? current : target;
            valueTo.textContent = utils.formatCurrency(displayValue);
          }

          // Atualizar o texto da dica baseado no progresso
          const tipElement = document.querySelector(SELECTORS.freeShippingTip);
          if (tipElement && (freeShippingLabel || freeShippingLabelSuccess)) {
            // Se alcançou ou ultrapassou o valor mínimo, mostrar mensagem de sucesso
            if (current >= target && freeShippingLabelSuccess) {
              tipElement.innerHTML = freeShippingLabelSuccess;
            } else if (freeShippingLabel) {
              // Senão, mostrar mensagem normal
              tipElement.innerHTML = freeShippingLabel;
            }
          }
        }
      };

      // Inicialização de eventos
      const initEvents = () => {
        const { SELECTORS } = CONFIG;

        $(document).on('click', '.shipping--value', e => {
          e.preventDefault();
          utils.toggleClasses([SELECTORS.shippingOverlay, SELECTORS.shipping], 'active');
        });

        const cartShippingClose = document.querySelector(SELECTORS.shippingClose);
        const cartShippingOverlay = document.querySelector(SELECTORS.shippingOverlay);
        if (cartShippingClose && cartShippingOverlay) {
          [cartShippingClose, cartShippingOverlay].forEach(el =>
            el.addEventListener('click', () =>
              utils.toggleClasses([SELECTORS.shippingOverlay, SELECTORS.shipping], 'active', false)
            )
          );
        }

        $(SELECTORS.shippingForm).on('submit', handleShippingSubmit);
        bindCouponEvents();

        bindAjaxComplete();
      };

      // Renderização de item do carrinho
      const renderCartItem = (item, deleteId) => {
        const brand = item.brand ? `<p class="cart-item-content-brand">${item.brand}</p>` : '';
        const price = utils.formatCurrency(item.unit_price);
        const variation = item.variation_value ? `<p class="cart-item-content-size">Tamanho: <b>${item.variation_value}</b></p>` : '';
        const giftClass = item.is_gift ? 'is-gift' : '';

        const el = document.createElement('li');
        el.className = `cart-item ${giftClass}`;
        el.setAttribute('data-product-id', item.id);
        el.innerHTML = `
          <figure><img src="${item.image_medium}" alt="${item.name}"></figure>
          <div class="cart-item-content">
            <h4 class="cart-item-content-name">${item.name}</h4>
            <p class="cart-item-content-price">${price}</p>
            <div class="variation-quantity">
              ${item.options.length > 0 ? `
                <select class="variation-select" data-original-id="${item.original_id}">
                  ${item.options.map(opt => `
                    <option 
                      value="${opt.product_id}" 
                      ${opt.product_id == item.original_id ? 'selected' : ''} 
                      ${!opt.available ? 'disabled' : ''}>
                        ${opt.value}
                    </option>
                  `).join('')}
                </select>
              ` : ''}
              <div class="group-quantity">
                <button class="btn-decrease" data-product="${item.original_id}" data-qtd="${item.quantity}">-</button>
                <span class="qtd-value">${item.quantity}</span>
                <button class="btn-increase" data-product="${item.original_id}" data-qtd="${item.quantity}">+</button>
              </div>
            </div>
            <button class="delete-item-button" data-original-id="${deleteId}"></button>
          </div>
        `;
        return el;
      };

      // Atualização dos contadores
      const updateCartCounters = (count, total, discount) => {
        const { SELECTORS } = CONFIG;
        const subtotal = Number(total) + Number(discount);

        document.querySelectorAll(SELECTORS.counters).forEach(el => {
          el.textContent = String(count).padStart(2, '0');
        });

        const elSubtotal = document.querySelector(SELECTORS.subtotal);
        if (elSubtotal) {
          elSubtotal.textContent = utils.formatCurrency(subtotal);
        }

        const elDuscount = document.querySelector(SELECTORS.discounts);
        if (elDuscount) {
          elDuscount.textContent = utils.formatCurrency(discount);
        }

        document.querySelector(SELECTORS.total).textContent = utils.formatCurrency(total);
      };

      // Vinculação de eventos do carrinho
      const bindCartEvents = () => {
        document.querySelectorAll('.delete-item-button').forEach(btn => {
          btn.onclick = () => deleteCartItem(btn.dataset.originalId);
        });

        document.querySelectorAll('.btn-increase').forEach(btn => {
          btn.onclick = () => {
            const qtd = parseInt(btn.dataset.qtd);
            updateItemQuantity(btn.dataset.product, qtd + 1);
          };
        });

        document.querySelectorAll('.btn-decrease').forEach(btn => {
          btn.onclick = () => {
            const qtd = parseInt(btn.dataset.qtd);
            qtd > 1
              ? updateItemQuantity(btn.dataset.product, qtd - 1)
              : deleteCartItem(btn.dataset.product);
          };
        });

        document.querySelectorAll('.variation-select').forEach(select => {
          select.addEventListener('change', function () {
            const selectedOption = this.options[this.selectedIndex];
            const newProductId = selectedOption.value;

            const cartItemEl = this.closest('.cart-item-content');
            const currentQty = parseInt(cartItemEl.querySelector('.qtd-value')?.textContent || 1, 10);

            const cartItem = this.closest('.cart-item');
            const itemId = cartItem.classList.contains('is-gift') ? cartItem?.querySelector('.delete-item-button')?.getAttribute('data-original-id') : cartItem?.getAttribute('data-product-id');
            const currentProductId = cartItem.querySelector('select')?.getAttribute('data-original-id');

            if (!itemId || !currentProductId || !newProductId) {
              console.error('IDs insuficientes para processar troca de variação.');
              return;
            }

            const payload = [{
              addon_values: "[]",
              as_free: false,
              is_buying_by_measure: false,
              item_id: itemId,
              product: currentProductId,
              new_product: newProductId,
              quantity: currentQty,
              replace_quantity: true
            }];

            $.ajax({
              type: 'POST',
              url: '/api/front/cart/items/?version=2',
              headers: { 'Content-Type': 'application/json' },
              dataType: 'json',
              data: JSON.stringify(payload)
            }).done(function (data) {
              if (data && data.cart_data && data.result) {
                updateCartPreview(data);
                select.setAttribute('data-original-id', newProductId);
              }
            }).fail(function (jqXHR, textStatus, errorThrown) {
              console.error('Erro ao trocar variação:', errorThrown);
              alert('Erro ao trocar o tamanho do produto.');
            });
          });
        });
      };

      // Atualização da pré-visualização do carrinho
      const updateCartPreview = (data) => {
        const { SELECTORS } = CONFIG;
        const container = document.querySelector(SELECTORS.cartPreview);
        if (!container) return;

        // Atualiza faixa de comunicado no header do carrinho, quando disponível
        if (data.cart_data && data.cart_data.faixa_comunicados) {
          const faixaRaw = data.cart_data.faixa_comunicados;
          const items = Array.isArray(faixaRaw) ? faixaRaw : (Array.isArray(faixaRaw?.items) ? faixaRaw.items : []);
          const faixaEl = document.querySelector('.cart-preview-header__faixa-comunicado');
          if (faixaEl) {
            faixaEl.innerHTML = '';

            items.forEach(function (item) {
              const desktopUrl = item.imagem_desktop || item.image_desktop || item.desktop || item.img_desktop || item.imagem;
              const mobileUrl = item.imagem_mobile || item.image_mobile || item.mobile || item.img_mobile;
              const altText = item.titulo || '';

              if (desktopUrl) {
                const imgDesktop = document.createElement('img');
                imgDesktop.src = desktopUrl;
                imgDesktop.alt = altText;
                imgDesktop.className = 'cart-preview-header__faixa-comunicado__img-desktop';
                faixaEl.appendChild(imgDesktop);
              }

              if (mobileUrl) {
                const imgMobile = document.createElement('img');
                imgMobile.src = mobileUrl;
                imgMobile.alt = altText;
                imgMobile.className = 'cart-preview-header__faixa-comunicado__img-mobile';
                faixaEl.appendChild(imgMobile);
              }
            });
          }
        }

        const currentTotal = data.cart_data.total_without_shipping || data.cart_data.total;
        if (data.cart_data.free_shipping_target) {
          // Esconde a faixa de frete se o target for '0.00'
          if (data.cart_data.free_shipping_target === '0.00' || data.cart_data.free_shipping_target === '0') {
            document.querySelectorAll('.cart-preview-free-shipping').forEach(el => el.classList.add('inactive'));
          } else {
            document.querySelectorAll('.cart-preview-free-shipping').forEach(el => el.classList.remove('inactive'));
          }
          utils.updateFreeShippingProgress(currentTotal, data.cart_data.free_shipping_target, data.cart_data.free_shipping_label, data.cart_data.free_shipping_label_success);
        }

        const list = container.querySelector(SELECTORS.itemsList);
        list.innerHTML = '';

        data.cart_data.items.forEach((item, index) => {
          const deleteId = data.result[index]?.id;
          list.appendChild(renderCartItem(item, deleteId));
        });

        updateCartCounters(data.result.length, data.cart_data.total_final, data.cart_data.total_discount);
        bindCartEvents();

        if (data.cart_data.coupon) {
          $(SELECTORS.couponInput).val(data.cart_data.coupon);
          $(SELECTORS.removeCoupon).addClass('active');
        }



        utils.updateFooterUtilsHeight(true);
      };

      // Recarregar pré-visualização
      const reloadCartPreview = () => {
        utils.ajaxRequest('GET', CONFIG.CART_ENDPOINT)
          .done(data => {
            if (data?.cart_data && data.result) {
              updateCartPreview(data);
            }
          });
      };

      // Remover item do carrinho
      const deleteCartItem = (id) => {
        utils.ajaxRequest('DELETE', '/api/front/cart/items/remove', [{ id }])
          .done(reloadCartPreview)
          .fail(err => console.log('Erro ao remover item do carrinho:', err));
      };

      // Atualizar quantidade do item
      const updateItemQuantity = (originalId, newQty) => {
        const payload = [{
          addon_values: "[]",
          as_free: false,
          is_buying_by_measure: false,
          product: originalId,
          quantity: newQty,
          replace_quantity: true,
        }];

        utils.ajaxRequest('POST', CONFIG.CART_ENDPOINT, payload)
          .done(data => {
            if (data?.cart_data && data.result) {
              updateCartPreview(data);
            }
          })
          .fail(jqXHR => {
            const data = jqXHR.responseJSON;
            if (Array.isArray(data) && data[0]?.stock) {
              alert(`O produto "${data[0].stock.product.name}" possui ${data[0].stock.quantity} unidade(s) em estoque.`);
            } else {
              alert('Ocorreu um erro inesperado ao atualizar a quantidade.');
            }
            console.log('Erro ao atualizar quantidade');
          });
      };

      // Vincular eventos de cupom
      const bindCouponEvents = () => {
        const { SELECTORS } = CONFIG;

        // Submit do cupom
        $('#js_form_coupon').on('submit', function (e) {
          e.preventDefault();
          const $form = $(this);
          const coupon = $form.find("input[name='coupon']").val();

          utils.ajaxRequest('PUT', '/api/front/cart/coupon/', { coupon })
            .done(() => {
              $(SELECTORS.removeCoupon).addClass('active');
              $form.removeClass('error').addClass('green').remove('invalid');
              // Recarregar a pré-visualização do carrinho para atualizar os valores
              reloadCartPreview();
            })
            .fail(() => {
              $form.removeClass('green').addClass('error').addClass('invalid');
            });
        });

        // Remoção do cupom
        $(SELECTORS.removeCoupon).on('click', function (e) {
          e.preventDefault();
          const $form = $('#js_form_coupon');

          utils.ajaxRequest('DELETE', '/api/front/cart/coupon/')
            .done(() => {
              $(SELECTORS.couponInput).val('');
              $(SELECTORS.removeCoupon).removeClass('active');
              $form.removeClass('green');
              reloadCartPreview();
            });
        });

        // Clique no input do cupom remove classes do form
        $('#js_form_coupon input[name="coupon"]').on('focus', function () {
          const $form = $('#js_form_coupon');
          $form.removeClass('green error invalid');
        });

      };

      // Manipular envio de frete
      const handleShippingSubmit = (e) => {
        e.preventDefault();
        const { SELECTORS } = CONFIG;
        const cep = $(SELECTORS.cepInput).val().replace(/['"]/g, ''); // Remove aspas simples ou duplas
        localStorage.setItem('cep', cep);

        const $loading = $('.shipping-loading');
        $loading.show();

        $.ajax({
          type: 'POST',
          url: '/produto/get-produto-frete/',
          data: { cep, show_delivery_shippings: true }, // Envia como form data, sem JSON
          dataType: 'json'
        }).done(data => {
          const shippings = data.shippings.shippings_available.shippings;
          const list = document.querySelector(SELECTORS.shippingList);
          if (!list) return;

          const hasMultiple = shippings.length > 1;

          const itemsHTML = shippings.map((s, i) => {
            let date = '';
            if (s.estimated_delivery_date != null && s.estimated_delivery_date !== '') {
              const [ano, mes, dia] = s.estimated_delivery_date.split('-');
              date = `${dia}/${mes}/${ano}`;
            }
            const cost = s.cost_label;

            return `
      <li class="cart-preview__shipping__list--item"
          data-index="${i}"
          data-shipping-id="${s.company_id}"
          data-shipping-cost="${cost}"
          data-shipping-name="${s.name}"
          data-shipping-price="${s.cost}"
          ${i > 0 ? 'style="display: none;"' : ''}>
        <div>
          <span>${s.name}</span>
          <span class="shipping--value">${cost}</span>
          <p>${s.delivery_time_days} ${s.label_delivery_time_days_checkout}</p>
          <p>Previsão ${date}</p>
        </div>
      </li>
    `;
          }).join('');

          const toggleBtn = hasMultiple
            ? `<button type="button" class="show-more-shippings" style="margin-top: 10px;">Ver mais opções de frete</button>`
            : '';

          list.innerHTML = itemsHTML + toggleBtn;

          requestAnimationFrame(() => {
            utils.updateFooterUtilsHeight(false);
          });

          if (hasMultiple) {
            const button = list.querySelector('.show-more-shippings');
            button?.addEventListener('click', () => {
              list.querySelectorAll('.cart-preview__shipping__list--item').forEach((li, i) => {
                if (i > 0) li.style.display = '';
              });
              button.style.display = 'none';
              utils.updateFooterUtilsHeight(false);
            });
          }
        })
          .fail(() => {
            alert('Erro ao calcular frete. Tente novamente.');
          })
          .always(() => {
            $loading.hide();
          });

      };

      // Vincular evento de conclusão de AJAX
      const bindAjaxComplete = () => {
        $(document).on("ajaxComplete", (event, xhr, settings) => {
          let payload = null;

          try {
            if (typeof settings.data === 'string') {
              payload = JSON.parse(settings.data);
            }
          } catch (err) {
            console.warn('settings.data não é um JSON válido:', settings.data);
            return; // early return para evitar seguir com payload inválido
          }

          if (
            settings.url.includes(CONFIG.CART_ENDPOINT) &&
            settings.type === 'POST' &&
            xhr.responseJSON?.result
          ) {
            reloadCartPreview();
            utils.addClasses(['.cart-preview'], 'active');
            $('.cart-preview--overlay').addClass('active');
            $('.shoppub-fast-buy-popup').removeClass('active');
            document.body.classList.add('no-scroll');
            document.documentElement.classList.add('no-scroll');
          }
        });
      };
      // Inicialização
      reloadCartPreview();
      initEvents();
    },
  },
  mounted() {
    if (view_origin !== 'checkout' && view_origin !== 'cart') {
      this.cartPreview();
    }

    const allTitles = document.querySelectorAll('.cart-preview__footer-utils li');
    if (allTitles.length > 0) {
      allTitles.forEach(li => {
        const open = li.querySelector('.cart-preview__footer-utils--title');
        const toggleBtn = li.querySelector('.open-close');
        if (open && toggleBtn) {
          open.addEventListener('click', () => {
            li.classList.toggle('active');
            toggleBtn.classList.toggle('active');
          })
        }
      })
    }
  }
});

// Cart has a delay and this code here fix it
setTimeout(() => {
  if (document.body.id === 'cart') {
    const elementosLazy = document.querySelectorAll('.lazy-img');

    elementosLazy.forEach(elemento => {
      const dataSrc = elemento.getAttribute('data-src');
      if (dataSrc) {
        elemento.setAttribute('src', dataSrc);
        elemento.removeAttribute('data-src');
      }
    });
  }
}, 5000);

/* Header Padding fix */
var page404Element = document.querySelector('.page-404');

if (page404Element) {
  page404Element.style.paddingTop = '133px';
  page404Element.style.setProperty('padding-top', '133px', 'important');
}

/* Name hover translate effect */
const figcaptionElements = document.querySelectorAll('.product-item__content--figcaption-name');

figcaptionElements.forEach((figcaption) => {
  const anchor = figcaption.querySelector('a');
  if (anchor) {
    const figcaptionWidth = figcaption.offsetWidth;
    const anchorWidth = anchor.offsetWidth;

    const transitionDuration = Math.max(1, Math.abs(anchorWidth - figcaptionWidth) / 100);

    if (anchorWidth > figcaptionWidth) {
      anchor.style.transition = `all ${transitionDuration}s linear`;
      figcaption.classList.add('action');
    }
  }
});

const observer = new MutationObserver((mutations) => {
  mutations.forEach(mutation => {
      if (mutation.attributeName === "class") {
          const target = mutation.target;
          if (target.classList.contains("active")) {
              const elementsToRemove = target.querySelectorAll(".product-item__content--figure .product-item__options");
              elementsToRemove.forEach(el => el.remove());
          }
      }
  });
});

document.querySelectorAll(".shoppub-fast-buy-popup").forEach(popup => {
  observer.observe(popup, { attributes: true, attributeFilter: ["class"] });
});

document.addEventListener("DOMContentLoaded", function () {

  (function ($) {
    $.fn.visible = function (partial) {

      var $t = $(this),
        $w = $(window),
        viewTop = $w.scrollTop(),
        viewBottom = viewTop + $w.height(),
        _top = $t.offset().top,
        _bottom = _top + $t.height(),
        compareTop = partial === true ? _bottom : _top,
        compareBottom = partial === true ? _top : _bottom;

      return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
    };

  })(jQuery);

  function loadWidgets(event) {
    $(".product-item:not(.widget-loaded)").each(function (i, el) {
      var $el = $(el);
      if ($el.visible(true)) {
        $el.addClass("widget-loaded");
        $el.children().trigger("mouseenter");

        setTimeout(() => {
          const domEl = el;
          const appendColors = domEl.querySelector('#append-colors');
          const colorsVariation = domEl.querySelector('.product__colors');

          if (appendColors && colorsVariation) {
            const cloneColorsVariation = colorsVariation.cloneNode(true);
            appendColors.appendChild(cloneColorsVariation);
          }
        }, 1000);

        $el.on("click", "input[id^='product_item_variation__product_detail']", function () {
          var input = $(this);
          var inputId = input.attr("id");
          var label = $el.find("label[for='" + inputId + "']");

          if (label.length && !label.hasClass("out-of-stock")) {
            setTimeout(function () {
              $el.find(".js-button-add-product-to-cart__product-list").trigger("click");
            }, 500);
          }
        });
      }
    });
  }

  // Adicionar mais eventos para melhor compatibilidade mobile
  $(window).on('scroll mousemove touchstart touchmove touchend', function () {
    loadWidgets();
  });

  // Garante execução no mobile após layout completo
  $(window).on('load', function () {
    setTimeout(loadWidgets, 300);
  });

  const containerShoppub = document.querySelector('#dynamic-page-extra .main-content .container-shoppub');
    if (containerShoppub) {
        const pageCustom = document.querySelector('#dynamic-page-extra .page-custom');
        if (pageCustom) {
            containerShoppub.classList.add('page-front');
        }
    }

  function moveThumbs() {
    if($('.product-detail__header--photoArea-thumbs-default') && $('#product-photo')) {
        document.querySelectorAll('.product-detail__header--photoArea-thumbs-default li').forEach((thumb, index) => {
            thumb.addEventListener('click', () => {
              const targetLi = document.querySelectorAll('#product-photo li')[index];
              if (targetLi) {
                targetLi.scrollIntoView({ behavior: 'smooth', block: 'center' });
              }
            });
        });
    }
  }
  moveThumbs()

  function loadSvg() {
    const svgs = document.querySelectorAll("[class^='no-svg-']");

    svgs.forEach(function (svg) {
      var oldClasses = svg.getAttribute("class");
      var newClasses = oldClasses.replace(/no-svg-/g, '');
      svg.setAttribute("class", newClasses);
    });
  }

  function onFirstInteraction() {
    loadSvg();
    window.removeEventListener('scroll', onFirstInteraction);
    window.removeEventListener('mousemove', onFirstInteraction);
  }

  window.addEventListener('scroll', onFirstInteraction, { passive: true });
  window.addEventListener('mousemove', onFirstInteraction, { passive: true });

  var elements = document.querySelectorAll('.product-campaigns-tags__campaign');

  Array.from(elements).forEach(function (tag) {
    if (tag.textContent.includes("Black") || tag.textContent.includes("BLACK") || tag.textContent.includes("black")) {
      tag.classList.add("black");
    }
  });
  
  // Adicionar evento específico para quando a página terminar de carregar
  $(document).ready(function() {
    loadWidgets();
  });

  function selectVariation(id, parent) {
    axios.get(`/api/front/product/${id}/get-linked-product/`).then(res => {
      const isProductItem = parent.classList.contains('product-item') ? true : false;
      const isModalPopup = parent.classList.contains('shoppub-fast-buy-popup') ? true : false;
      let productName = '';
      let radioVariations = '';
      let getBody = '';
      let dataIdAuto = '';
      //seleciona os elementos a serem alterados
      if (isProductItem) {
        productName = parent.querySelector('.product-item__content--figcaption-name a');
        radioVariations = parent.querySelector(".product-radio-variation");
        getBody = parent.firstElementChild;
        dataIdAuto = radioVariations && radioVariations.querySelector('input') ? radioVariations.querySelector('input').getAttribute('data-id-auto') : '';
        const buttonId = parent.querySelector('.js-button-add-product-to-cart__product-list');
        if (buttonId) {
          buttonId.setAttribute('data-id', res.data.id);
        }
      } else if (isModalPopup) {
        productName = parent.querySelector('.product-item__content--figcaption-name a');
        radioVariations = parent.querySelector(".product-radio-variation");
        getBody = parent.firstElementChild;
        dataIdAuto = parent.querySelector('.product-radio-variation input') ? parent.querySelector('.product-radio-variation input').getAttribute('data-id-auto') : '';
        const buttonId = parent.querySelector('.js-button-add-product-to-cart__product-list');
        if (buttonId) {
          buttonId.setAttribute('data-id', res.data.id);
        }
      } else {
        productName = parent.querySelector('#js-product_name__product_detail_');
        radioVariations = parent.querySelector(".product-detail__header--infoArea-kit .product-radio-variation");
        getBody = document.querySelector('body');
      }

      const linkName = "/produto/" + res.data.slug;
      //troca o nome do produto
      if (productName) {
        productName.innerHTML = res.data.name
        if (productName.tagName.toLowerCase() === 'a') {
          //substitui o link href da tag a (ainda experimental pois há variaveis, nao funciona sempre)
          productName.href = linkName;
        }
      }

      if (res.data.variations.length > 0) {
        $(radioVariations).html('');
        if (radioVariations && !isProductItem) {
          $(radioVariations).append('<p class="label_attributes"> escolha o tamanho </p>');
        }
        res.data.variations.forEach(function (variation) {
          const radioInput = $(`<input type="radio" name="product_item_variation__product_detail_${dataIdAuto}_${res.data.id}" id="product_item_variation__product_detail_${dataIdAuto}_${variation.id}" value="${variation.id}" data-id-auto="${dataIdAuto}" data-variation-name="${variation.main_attribute.name}" data-origin-location="product_detail">`);

          const radioLabel = $(`<label for="product_item_variation__product_detail_${dataIdAuto}_${variation.id}" class="label_radio ${!variation.available ? "out-of-stock" : ""} radio"><span>${variation.main_attribute.value}</span></label>`);

          radioLabel.on('click', function () {
            getBody.setAttribute('data-id-current', variation.id)
          });

          $(radioVariations).append(radioInput).append(radioLabel);
        })
      }

      if (isProductItem) {
        const figure = parent.querySelector('.product-item__content .product-item__content--figure a');
        figure.href = linkName;

        if (figure) { // Verifique se figure não é null
          figure.innerHTML = ''; // Limpa o conteúdo existente
          if (res.data.images.length > 0) {
            figure.innerHTML = `<a href="${linkName}" class="w-100"><img src="${res.data.images[0]}" alt="${res.data.name}" class="block-img lazy-img no-hover b-error"> <span class="product-item__content--figure-loading"></span></a>`;
          }
        }
      } else if (isModalPopup) {
        const figure = parent.querySelector('.product-item__content--figure a');
        figure.href = linkName;

        if (figure) { // Verifique se figure não é null
          figure.innerHTML = ''; // Limpa o conteúdo existente
          if (res.data.images.length > 0) {
            figure.innerHTML = `<a href="${linkName}" class="w-100"><img src="${res.data.images[0]}" alt="${res.data.name}" class="block-img lazy-img no-hover b-error"> <span class="product-item__content--figure-loading"></span></a>`;
          }
        }
      } else {
        const keepBuyingName = document.querySelector('#js-product_name__product_detail_keeping_buying');
        const keepBuyingImage = document.querySelector('.keeping-buying__figure--image');

        if (keepBuyingName && keepBuyingImage) {
          keepBuyingName.innerHTML = res.data.name;
          keepBuyingImage.setAttribute('src', `${res.data.images[0]}`);
        }

        if ($('.mobile-slider .slider-single').hasClass('slick-initialized')) {
          $('.mobile-slider .slider-single').slick('unslick');
        }
        if ($('.mobile-slider .slider-nav').hasClass('slick-initialized')) {
          $('.mobile-slider .slider-nav').slick('unslick');
        }

        $('.product-detail__header--photoArea-mobile').slick('removeSlide', null, null, true);
        $('.product-detail__header--photoArea-photo ul').html('');
        $('.product-detail__header--photoArea-thumbs-default ul').html('');
        $('.mobile-slider .slider-single').html('');
        $('.mobile-slider .slider-nav').html('');
        if (res.data.images.length > 0) {
          res.data.images.forEach(function (image, index) {
            $('.product-detail__header--photoArea-mobile').slick('slickAdd', `<li style="width: 100%;"><a href="${image}"><img src="${image}" class="product-detail__header--photoArea-mobile-img"/></a></li>`);
            $('.product-detail__header--photoArea-photo ul').append(`<li class="sp-wrap" id="photo-${index}"><a href="${image}" data-fancybox="gallery1"><img src="${image}" class="product-detail__header--photoArea-mobile-img"/></a></li>`);
            $('.product-detail__header--photoArea-thumbs-default ul').append(`<li class="sp-wrap" id="photo-${index}"><img src="${image}" class="product-detail__header--photoArea-mobile-img"/></li>`);
            $('.mobile-slider .slider-single').append(`<a href="${image}" data-fancybox="gallery3"><img src="${image}"/></a>`);
            $('.mobile-slider .slider-nav').append(`<li><img src="${image}"/></li>`);
          });
        }

        moveThumbs();

        $('.mobile-slider .slider-single').slick({
          swipeToSlide: true, 
          touchThreshold: 100,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          fade: false,
          infinite: false,
          mobileFirst: true,
          speed: 700,
          vertical: false,
          responsive: [
              {
                  breakpoint: 991,
                  settings: "unslick"
              },
          ]
        });
    
        $('.mobile-slider .slider-nav').slick({
          swipeToSlide: true, 
          touchThreshold: 100,
          slidesToShow: 4, // ou quantas thumbs quiser mostrar
          slidesToScroll: 1,
          asNavFor: '.slider-single',
          focusOnSelect: true,
          centerMode: false, // opcional
          arrows: false, // ou false se quiser ocultar as setas
          infinite: false,
          mobileFirst: true,
          speed: 700,
          vertical: false,
          responsive: [
              {
                  breakpoint: 991,
                  settings: "unslick"
              },
          ]
        });
      }

      if (getBody) {
        getBody.setAttribute('data-id', `${id}`);
        getBody.setAttribute('data-id-current', `${id}`);
      }
    }).catch(err => { console.log(err); });
  }

  document.body.addEventListener('click', function (event) {
    const clickedColor = event.target.closest('.product__colors-item, .product__colors-box');
    if (!clickedColor) return;
  
    const isProductItem = !!event.target.closest('.product-item');
    const isModalPopup = !!event.target.closest('.shoppub-fast-buy-popup');
  
    if (isProductItem || isModalPopup) {
      event.preventDefault();
  
      const productItem = isProductItem
        ? (event.target.closest('.product-item') || event.target.closest('.product-detail__header'))
        : event.target.closest('.shoppub-fast-buy-popup');
  
      const targetColor = clickedColor.classList.contains('product__colors-item')
        ? clickedColor
        : clickedColor.closest('.product__colors-item');
  
      if (!productItem || !targetColor) return;
  
      const allColorOptions = productItem.querySelectorAll('.product__colors-item');
      allColorOptions.forEach(option => {
        option.classList.remove('is-selected');
      });
      targetColor.classList.add('is-selected');
  
      const selected = targetColor.getAttribute('variation-id');
      selectVariation(selected, productItem);

      if(isModalPopup){
        const figureModal = document.querySelector('.product-item__content--figure');
        const name = document.querySelector('.product-item__content--figcaption-name');
        figureModal.appendChild(name);
      }
    }
  });

  waitForElementToExist('.shoppub-fast-buy-popup .product-item__content--figure').then(element => { 
    const figure = document.querySelector('.product-item__content--figure');
    const name = document.querySelector('.product-item__content--figcaption');
    figure.appendChild(name);
  })

  if(view_origin === 'checkout') {
    // Observer para quando .order-bump receber a classe 'loaded'
    const observedElements = new WeakSet();
    
    const orderBumpObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const target = mutation.target;
          if (target.classList.contains('loaded')) {
            const productItem = document.querySelector('.product-item');
            if (productItem && typeof $ !== 'undefined') {
              $(productItem).children().trigger("mouseenter");
            }
          }
        }
      });
    });

    // Observer para detectar quando novos elementos .order-bump são adicionados ao DOM
    const containerObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          // Verifica se algum nó adicionado é um .order-bump ou contém um
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) { // Element node
              let orderBump = null;
              if (node.classList && node.classList.contains('order-bump')) {
                orderBump = node;
              } else {
                orderBump = node.querySelector && node.querySelector('.order-bump');
              }
              
              if (orderBump && !observedElements.has(orderBump)) {
                observedElements.add(orderBump);
                orderBumpObserver.observe(orderBump, {
                  attributes: true,
                  attributeFilter: ['class']
                });
              }
            }
          });
        }
      });
    });

    // Inicia a observação do container e dos elementos existentes
    const startObserving = () => {
      // Observa o body ou um container específico para detectar novos elementos
      const container = document.querySelector('.checkout-step__3') || document.body;
      if (container) {
        containerObserver.observe(container, {
          childList: true,
          subtree: true
        });
        
        // Observa elementos .order-bump que já existem
        const existingOrderBumps = document.querySelectorAll('.order-bump');
        existingOrderBumps.forEach(function(orderBump) {
          if (!observedElements.has(orderBump)) {
            observedElements.add(orderBump);
            orderBumpObserver.observe(orderBump, {
              attributes: true,
              attributeFilter: ['class']
            });
          }
        });
      } else {
        // Se não encontrar o container, tenta novamente após um delay
        setTimeout(startObserving, 100);
      }
    };

    startObserving();
  }

});